<h2 mat-dialog-title>
  {{ data.mode === 'create' ? 'Add Collection Code' : 'Edit Collection Code' }}
</h2>

<mat-dialog-content class="event-dialog-content">
  <mat-form-field appearance="outline">
    <mat-label>Code</mat-label>
    <input
      matInput
      maxlength="50"
      [ngModel]="values.code"
      [ngModelOptions]="{ standalone: true }"
      (ngModelChange)="onCodeChanged($event)"
      [readonly]="data.mode === 'edit'"
      required
    />
    <mat-hint align="end" *ngIf="data.mode === 'create'"
      >{{ values.code.length }}/50</mat-hint
    >
    <mat-hint *ngIf="data.mode === 'edit'">
      To change the code, delete it and add a new one
    </mat-hint>
    <mat-hint class="code-error" *ngIf="codeError">{{ codeError }}</mat-hint>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Collection Type</mat-label>
    <mat-select
      [(ngModel)]="values.collectionType"
      [ngModelOptions]="{ standalone: true }"
      required
    >
      <mat-option
        *ngFor="let collectionType of collectionTypes"
        [value]="collectionType"
      >
        {{ collectionType }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <div class="number-fields">
    <mat-form-field appearance="outline">
      <mat-label>Effort</mat-label>
      <input
        matInput
        type="number"
        step="0.01"
        min="0"
        [(ngModel)]="values.effort"
        [ngModelOptions]="{ standalone: true }"
        required
      />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Event Grade</mat-label>
      <input
        matInput
        type="number"
        min="0"
        [(ngModel)]="values.eventGrade"
        [ngModelOptions]="{ standalone: true }"
        required
      />
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="close()">Cancel</button>
  <button
    mat-flat-button
    color="primary"
    type="button"
    [disabled]="!allValid"
    (click)="submit()"
  >
    {{ data.mode === 'create' ? 'Add' : 'Save' }}
  </button>
</mat-dialog-actions>
